import { HttpClient, HttpParams } from '@angular/common/http';
import { Variable } from '@angular/compiler/src/render3/r3_ast';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { interval } from 'rxjs';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContractsComponent implements OnInit {


  ContractName: string;
  PurchaseNumber: string;
  ContractNumber: string;
  Service: string;
  Validfrom: any;
  ValidTo: any;
  CompanyName: string;
  CompanyRole: string;
  CompanyDate: any;
  ClientName: string;
  ClientRole: string;
  ClientDate: any;
  description: string;
  ContractExport = [] as any;
  public searchText: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShowndoclist: boolean = true;
  Addcomp = [] as any;
  Adclient = [] as any;
  imageurl: string;
  contracts = [];
  onboardingid: string;
  customcode: string;
  lblname: string;
  myFiles: string[] = [];
  CountryExport = [] as any;
  isShownimage: boolean = true;
  selects = [] as any;
  select = [] as any;
  doclist: string;
  surl: string;
  EditedContract = [] as any;
  EditedContractId: string;
  Status: boolean = false;
  ContractCompany = [] as any;
  ContractCompanyRemove = [] as any;
  ContractClientRemove = [] as any;
  ContractClient = [] as any;
  EditedCompanyId: string;
  EditedClientId: string;
  EditedDoc = [] as any;
  EditedDocId: string;
  updatedocid = [] as any;
  vardocid = [] as any;
  varurl = [] as any;
  dropdownList: any = [];
  dropdownSettings: IDropdownSettings;
  type: string;
  //List:string;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId: string;
  sOldOnboadId:string;
  

  displayedColumns: string[] = ['sno', 'contractNo', 'services', 'validfrom1', 'validto1', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  

  @ViewChild('file')
  myInputVariable: ElementRef;
  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('ContractsRead');
    this.vWrite = localStorage.getItem('ContractsWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    this.sOldOnboadId=this.sOnboardingId;
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('', 'Please Select A Customer First!');
    }   
    this.BindContractGrid();
    this.BindOnboardDDL();
    this.BindContractExport();
    this.ContractCompany.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
    this.ContractClient.push({ ClientName: "vClientName1", ClientRole: "vClientRole1", ClientDate: "vClientDate1" });
    interval(3000).subscribe(x => {
      this.sOnboardingId = localStorage.getItem('OnboardingId');
      if (this.sOldOnboadId != this.sOnboardingId) {
        this.BindContractGrid();
        this.BindOnboardDDL();
        this.BindContractExport();
      this.sOldOnboadId=this.sOnboardingId;
      }
    });
    this.dropdownList = [
      { item_id: 1, item_text: 'Post Audit' },
      { item_id: 2, item_text: 'Broker Rationalization' },
      { item_id: 3, item_text: 'Trade Compliance' },
      { item_id: 4, item_text: 'Classification & FTA' }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };   
    //console.log(this.select + "1")
  }

  onItemSelect(item: any) {
    debugger;
    if (this.type == undefined || this.type == null || this.type == "") {
      this.type = item.item_text;
    }
    else {
      this.type = this.type + "," + item.item_text;
    }
  }
  onSelectAll(item: any) {
    debugger;
    if (item.length > 0) {
      for (var i = 0; i < item.length; i++) {
        if (this.type == undefined || this.type == null || this.type == "") {
          var items = item[i];
          this.type = items.item_text;
          debugger;
        }
        else {
          var items = item[i];
          this.type = this.type + "," + items.item_text;
          debugger;
        }
      }
    }

  }
  onItemDeSelect(item: any) {
    debugger;
    var vItmsTyp = this.type.split(',');
    this.type = "";
    for (var i = 0; i < vItmsTyp.length; i++) {
      if (item.item_text == vItmsTyp[i]) {

      }
      else {
        if (this.type == undefined || this.type == null || this.type == "") {
          this.type = vItmsTyp[i];
        }
        else {
          this.type = this.type + "," + vItmsTyp[i];
        }
      }
    }
  }

  BindOnboardDDL() {
    var value = this.http.get(environment.apiUrl + 'Contract/GetOnboardDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.contracts = data;
          //this.onboardingid = "0";
          var vcustomcode = this.sOnboardingId;
          this.onboardingid =vcustomcode;
          debugger;
        }
        else {
        };
      });
  }

  public uploadFile = (files) => {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    debugger;
    if (files.length == 0) {
      return;
    }
    for (var i = 0; i < files.length; i++) {
      this.myFiles.push(files[i]);
    }
    debugger;
    //let fileToUpload = <File>files[0];
    const formData = new FormData();
    //formData.append('file', fileToUpload, fileToUpload.name);
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file[]", this.myFiles[i]);
    }

    this.http.post(environment.apiUrl + 'Contract/UploadContent', formData).subscribe(
      (response) => {
        debugger;
        alert(response);
      },
      (error) => {
        debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Upload Failed, Please Try Again.";
          return false;
        }
        else {
          this.surl = vErrorMsg1;
          var spliturl = vErrorMsg1.split(",");
          for (var i = 0; i < spliturl.length; i++) {
            this.isShownimage = false;
            this.isShowndoclist = false;
            var furl = spliturl[i];
            var cvname = furl.split("/");
            var fname = cvname[7];
            this.selects.push({ filename: fname, fileURL: furl });
            this.imageurl = furl;
            this.isShownSuccess = false;
            this.SuccessMsg = "File Uploaded"
            this.myFiles = [];
            this.myInputVariable.nativeElement.value = "";
          }
        }
      }
    )

  }

  SubmitContract() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownUpdateBtn = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    var vContractName = this.onboardingid;
    var vPurchaseNumber = this.PurchaseNumber;
    var vContractNumber = this.ContractNumber;
    var vService = this.type;
    var vValidfrom = this.Validfrom;
    var vValidTo = this.ValidTo;
    var vdescription = this.description;

    debugger;
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    this.sOldOnboadId=this.sOnboardingId;
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('', 'Please Select A Customer First!');
      return;
    }   
    if (vContractName == undefined || vContractName == "" || vContractName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select A Customer First.";
      return false;
    }

    if (vContractNumber == undefined || vContractNumber == "" || vContractNumber == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Contract Number.";
      return false;
    }

    if (vPurchaseNumber == undefined || vPurchaseNumber == "" || vPurchaseNumber == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Purchase Number.";
      return false;
    }

    if (vService == undefined || vService == "" || vService == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Services.";
      return false;
    }

    if (vValidfrom == undefined || vValidfrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid From Date.";
      return false;
    }

    if (vValidTo == undefined || vValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid To Date.";
      return false;
    }
    if (vValidfrom > vValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should Greater then Valid From Date.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = "";
    }

    if (this.ContractCompany != null) {
      if (this.ContractCompany.length != 0) {
        for (var i = this.ContractCompany.length - 1; i >= 0; i--) {
          var v1 = this.ContractCompany[i].CompanyName;
          var v2 = this.ContractCompany[i].CompanyRole;
          var v3 = this.ContractCompany[i].CompanyDate;
          debugger;
          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarCompanyName == undefined || vVarCompanyName == "" || vVarCompanyName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Company.";
            return false;
          }

          if (vVarCompanyRole == undefined || vVarCompanyRole == "" || vVarCompanyRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Role.";
            return false;
          }

          if (vVarCompanyDate == undefined || vVarCompanyDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Date.";
            return false;
          }

          if (vValidfrom > vVarCompanyDate || vValidTo < vVarCompanyDate) {
            this.isShownError = false;
            this.ErrorMsg = "Company Signed Date should between Valid From and Valid To Date .";
            return false;
          }


        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Company Details..";
      return false;
    }
    debugger;
    if (this.ContractClient != null) {
      if (this.ContractClient.length != 0) {
        for (var i = this.ContractClient.length - 1; i >= 0; i--) {
          var v1 = this.ContractClient[i].ClientName;
          var v2 = this.ContractClient[i].ClientRole;
          var v3 = this.ContractClient[i].ClientDate;
          debugger;
          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarClientName == undefined || vVarClientName == "" || vVarClientName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Client.";
            return false;
          }

          if (vVarClientRole == undefined || vVarClientRole == "" || vVarClientRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Role.";
            return false;
          }

          if (vVarClientDate == undefined || vVarClientDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Date.";
            return false;
          }

          if (vValidfrom > vVarClientDate || vValidTo < vVarClientDate) {
            this.isShownError = false;
            this.ErrorMsg = "Client Signed Date should between Valid From and Valid To Date .";
            return false;
          }
        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Client Details..";
      return false;
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dContractName', this.onboardingid);
    params = params.append('dPurchaseNumber', this.PurchaseNumber);
    params = params.append('dContractNumber', this.ContractNumber);
    params = params.append('dService', this.type);
    params = params.append('dValidfrom', this.Validfrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('ddescription', this.description);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Contract/InsertContract', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var ContractId = data;

        for (var i = this.ContractCompany.length - 1; i >= 0; i--) {
          var v1 = this.ContractCompany[i].CompanyName;
          var v2 = this.ContractCompany[i].CompanyRole;
          var v3 = this.ContractCompany[i].CompanyDate;

          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params1 = new HttpParams();
          params1 = params1.append('iContractId', ContractId);
          params1 = params1.append('iCompanyName', vVarCompanyName);
          params1 = params1.append('irole', vVarCompanyRole);
          params1 = params1.append('iDate', vVarCompanyDate);
          var value = this.http.get(environment.apiUrl + 'Contract/InsertContractsCompany', { params: params1 }).toPromise().then((data))
        }
        for (var i = this.ContractClient.length - 1; i >= 0; i--) {
          var v1 = this.ContractClient[i].ClientName;
          var v2 = this.ContractClient[i].ClientRole;
          var v3 = this.ContractClient[i].ClientDate;

          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params2 = new HttpParams();
          params2 = params2.append('sContractId', ContractId);
          params2 = params2.append('sCompanyName', vVarClientName);
          params2 = params2.append('srole', vVarClientRole);
          params2 = params2.append('sDate', vVarClientDate);
          var value1 = this.http.get(environment.apiUrl + 'Contract/InsertContractsClient', { params: params2 }).toPromise().then((data))
        }
        var spliturl = this.surl;
        debugger;
        // for (var i = 0; i < spliturl.length; i++) {
        //   var furl = spliturl[i];
        if (spliturl != undefined && spliturl != "") {
          let params3 = new HttpParams();
          params3 = params3.append('sContractId', ContractId);
          params3 = params3.append('sfurl', spliturl);
          var value2 = this.http.get(environment.apiUrl + 'Contract/InsertContractsDoc', { params: params3 }).toPromise().then(
            (data: any) => {
              debugger;
              this.isShownSuccess = false;
              this.SuccessMsg = "Contracts Added.";
              this.BindContractGrid();
              this.BindContractExport();
              this.isShownActive = true;
              this.ContractName = "";
              this.PurchaseNumber = "";
              this.ContractNumber = "";
              this.select = "";
              this.Service = "";
              this.Validfrom = "";
              this.ValidTo = "";
              this.CompanyName = "";
              this.CompanyRole = "";
              this.CompanyDate = "";
              this.ClientName = "";
              this.ClientRole = "";
              this.ClientDate = "";
              this.description = "";
              //this.onboardingid = "";
              this.surl = "";
              this.type = "";
              this.selects = [];
              this.ContractCompany = [];
              this.ContractCompany.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
              this.ContractClient = [];
              this.ContractClient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
              this.isShowndoclist = true;
            }).catch((data: any) => {
              debugger;
              var vDataError = JSON.stringify(data.error.text);
              var vErrorMsg = vDataError.replace('"', '');
              this.isShownSuccess = false;
              this.SuccessMsg = "Contracts Added.";
              this.BindContractGrid();
              this.BindContractExport();
              this.isShownActive = true;
              this.ContractName = "";
              this.PurchaseNumber = "";
              this.ContractNumber = "";
              this.select = "";
              this.Service = "";
              this.Validfrom = "";
              this.ValidTo = "";
              this.CompanyName = "";
              this.CompanyRole = "";
              this.CompanyDate = "";
              this.ClientName = "";
              this.ClientRole = "";
              this.ClientDate = "";
              this.description = "";
              //this.onboardingid = "";
              this.surl = "";
              this.type = "";
              this.selects = [];
              this.ContractCompany = [];
              this.ContractCompany.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
              this.ContractClient = [];
              this.ContractClient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
              this.isShowndoclist = true;
            })
        }
        else {
          this.isShownSuccess = false;
          this.SuccessMsg = "Contracts Added.";
          this.BindContractGrid();
          this.BindContractExport();
          this.isShownActive = true;
          this.ContractName = "";
          this.PurchaseNumber = "";
          this.ContractNumber = "";
          this.select = "";
          this.Service = "";
          this.Validfrom = "";
          this.ValidTo = "";
          this.CompanyName = "";
          this.CompanyRole = "";
          this.CompanyDate = "";
          this.ClientName = "";
          this.ClientRole = "";
          this.ClientDate = "";
          this.description = "";
          //this.onboardingid = "";
          this.surl = "";
          this.type = "";
          this.selects = [];
          this.ContractCompany = [];
          this.ContractCompany.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
          this.ContractClient = [];
          this.ContractClient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
          this.isShowndoclist = true;
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Contract Number Already Exist."
          return false;
        }
        else {

        }
      });

  }

  ClearContract() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownUpdateBtn = true;
    this.isShownSaveBtn = false;
    this.isShownActive = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vcustomcode = this.sOnboardingId;
    this.onboardingid =vcustomcode;
    this.PurchaseNumber = "";
    this.ContractNumber = "";
    this.Service = "";
    this.select = "";
    this.Validfrom = "";
    this.ValidTo = "";
    this.CompanyName = "";
    this.CompanyRole = "";
    this.CompanyDate = "";
    this.ClientName = "";
    this.ClientRole = "";
    this.ClientDate = "";
    this.description = "";
    this.surl = "";
    this.type = "";
    this.isShowndoclist = true;
    this.myFiles = [];
    this.selects = [];
    //this.List="";
    this.ContractCompany = [];
    this.ContractCompany.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
    this.ContractClient = [];
    this.ContractClient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
  }

  AddCompany() {
    debugger;
    //vCompanyName1, CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
    var vLength = this.ContractCompany.length;
    var v1 = "vCompanyName" + (vLength + 1);
    var v2 = "vCompanyRole" + (vLength + 1);
    var v3 = "vCompanyDate" + (vLength + 1);
    this.ContractCompany.push({ CompanyName: v1, CompanyRole: v2, CompanyDate: v3, ContractsId: "" });
  }

  AddClient() {
    debugger;
    var vLength = this.ContractClient.length;
    var v1 = "vClientName" + (vLength + 1);
    var v2 = "vClientRole" + (vLength + 1);
    var v3 = "vClientDate" + (vLength + 1);
    this.ContractClient.push({ ClientName: v1, ClientRole: v2, ClientDate: v3, ContractsId: "" });
  }

  EditContract(item: any) {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedContract = item;
    debugger;

    var vcontractid = this.EditedContract.contractid;
    var vname = this.EditedContract.name;
    var vpurchaseno = this.EditedContract.purchaseNo;
    var vcontractNo = this.EditedContract.contractNo;
    var vservices = this.EditedContract.services;
    var vvalidfrom = this.EditedContract.validfrom;
    var vvalidto = this.EditedContract.validto;
    var vdescription = this.EditedContract.description;
    var vstatus = this.EditedContract.status;
    debugger;
    this.onboardingid = vname;
    this.PurchaseNumber = vpurchaseno;
    this.ContractNumber = vcontractNo;
    //this.Service = vservices;

    if (vservices != null || vservices != undefined || vservices != "") {
      var Stype = vservices.split(",");
      this.select = [];
      this.type = "";
      for (var i = 0; i < Stype.length; i++) {
        var vText = Stype[i];
        var vItmId = 0;
        switch (Stype[i]) {
          case "Post Audit":
            vItmId = 1;
            break;
          case "Broker Rationalization":
            vItmId = 2;
            break;
          case "Trade Compliance":
            vItmId = 3;
            break;
          case "Classification & FTA":
            vItmId = 4;
            break;
        }
        this.select.push({ item_id: vItmId, item_text: vText });
        if (this.type == undefined || this.type == null || this.type == "") {
          this.type = vText;
        }
        else {
          this.type = this.type + "," + vText;
        }

      }
    }
    this.Validfrom = new Date(new Date(vvalidfrom).setDate(new Date(vvalidfrom).getDate() + 1)).toISOString().split('T')[0];
    this.ValidTo = new Date(new Date(vvalidto).setDate(new Date(vvalidto).getDate() + 1)).toISOString().split('T')[0];
    this.description = vdescription;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
    this.EditedContractId = vcontractid;
    var value1 = this.http.get(environment.apiUrl + 'Contract/GetCompanyForEdit?contractID=' + vcontractid).toPromise().then(
      (data: any) => {

        if (data.length != 0) {
          var vData = data;

          var vcompanyid = vData["0"].cCompanyId;
          this.EditedCompanyId = vcompanyid;
          //this.ContractCompany = [] as any;
          this.ContractCompany = [];
          for (var i = 0; i < data.length; i++) {
            var vLength = 0;
            if (this.ContractCompany == null)
              vLength = 0;
            else
              vLength = this.ContractCompany.length;
            var v1 = "CompanyName" + (i + 1);
            var v2 = "CompanyRole" + (i + 1);
            var v3 = "CompanyDate" + (i + 1);
            var v4 = "companyvar" + (vLength + 1);
            var vccompanyId = vData[i].cCompanyId;


            this.ContractCompany.push({ CompanyName: v1, CompanyRole: v2, CompanyDate: v3, CompanyId: vccompanyId, companyvar: v4 });

          }
          setTimeout(() => {

            for (var j = 0; j < this.ContractCompany.length; j++) {


              var v11 = this.ContractCompany[j].CompanyName;
              var v12 = this.ContractCompany[j].CompanyRole;
              var v13 = this.ContractCompany[j].CompanyDate;


              var CompanyName = vData[j].cpysignedby;
              var CompanyRole = vData[j].cpysignedrole;
              var CompanyDate = vData[j].cpysigneddate;


              if (CompanyName != null) {
                ((document.getElementById(v11) as HTMLInputElement).value) = CompanyName;
              }

              if (CompanyRole != null) {
                ((document.getElementById(v12) as HTMLInputElement).value) = CompanyRole;
              }
              if (CompanyDate != null) {
                var vvcmpnydate = CompanyDate;
                CompanyDate = new Date(new Date(vvcmpnydate).setDate(new Date(vvcmpnydate).getDate() + 1)).toISOString().split('T')[0];
                ((document.getElementById(v13) as HTMLInputElement).value) = CompanyDate;
              }
            }

          }, 2000);
        }
        else {

        }
      });

    var value2 = this.http.get(environment.apiUrl + 'Contract/GetClentForEdit?contractID=' + vcontractid).toPromise().then(
      (data: any) => {

        if (data.length != 0) {
          var vData1 = data;

          var vclientid = vData1["0"].cclientId;
          this.EditedClientId = vclientid;
          //this.ContractClient = [] as any;
          this.ContractClient = [];
          for (var n = 0; n < data.length; n++) {
            var vLength = 0;
            if (this.ContractClient == null)
              vLength = 0;
            else
              vLength = this.ContractClient.length;
            var v1 = "ClientName" + (n + 1);
            var v2 = "ClientRole" + (n + 1);
            var v3 = "ClientDate" + (n + 1);
            var v4 = "clientvar" + (vLength + 1);
            var vcclientId = vData1[n].cclientId;


            this.ContractClient.push({ ClientName: v1, ClientRole: v2, ClientDate: v3, ClientId: vcclientId, clientvar: v4 });

          }

          setTimeout(() => {


            for (var k = 0; k < this.ContractClient.length; k++) {


              var v11 = this.ContractClient[k].ClientName;
              var v12 = this.ContractClient[k].ClientRole;
              var v13 = this.ContractClient[k].ClientDate;


              var ClientName = vData1[k].clsignedby;
              var ClientRole = vData1[k].clsignedrole;
              var ClientDate = vData1[k].clsigneddate;


              if (ClientName != null) {
                ((document.getElementById(v11) as HTMLInputElement).value) = ClientName;
              }
              debugger;
              if (ClientRole != null) {
                ((document.getElementById(v12) as HTMLInputElement).value) = ClientRole;
              }
              if (ClientDate != null) {
                var vvclientdate = ClientDate;
                ClientDate = new Date(new Date(vvclientdate).setDate(new Date(vvclientdate).getDate() + 1)).toISOString().split('T')[0];
                ((document.getElementById(v13) as HTMLInputElement).value) = ClientDate;
              }
            }

          }, 2000);
        }
        else {

        }
      });
    debugger;
    //this.updatedocid = [];
    this.selects = [];
    var value3 = this.http.get(environment.apiUrl + 'Contract/GetDocForEdit?contractID=' + vcontractid).toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          var vData1 = data;
          debugger;
          for (var i = 0; i < vData1.length; i++) {
            this.EditedDoc = vData1[i];
            var vdocId = this.EditedDoc.cdocId;
            var vdocurl = this.EditedDoc.docUrl;
            var furl = vdocurl;
            this.isShownimage = false;
            this.isShowndoclist = false;
            var cvname = furl.split("/");
            var fname = cvname[6];
            this.selects.push({ docid: vdocId, filename: fname, fileURL: furl });
            //this.updatedocid.push({ updocid: vdocId, upfileurl: furl });
            //var fdocid = this.updatedocid;                 
          }

        }
      });

  }


  UpdateContract() {

    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownSaveBtn = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vContractName = this.onboardingid;
    var vPurchaseNumber = this.PurchaseNumber;
    var vContractNumber = this.ContractNumber;
    var vService = this.type;
    var vValidfrom = this.Validfrom;
    var vValidTo = this.ValidTo;
    var vdescription = this.description;
    debugger;

    if (vContractName == undefined || vContractName == "" || vContractName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select A Customer First.";
      return false;
    }

    if (vContractNumber == undefined || vContractNumber == "" || vContractNumber == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Contract Number.";
      return false;
    }

    if (vPurchaseNumber == undefined || vPurchaseNumber == "" || vPurchaseNumber == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Purchase Number.";
      return false;
    }

    if (vService == undefined || vService == "" || vService == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Services.";
      return false;
    }

    if (vValidfrom == undefined || vValidfrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid From Date.";
      return false;
    }

    if (vValidTo == undefined || vValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid To Date.";
      return false;
    }
    if (vValidfrom > vValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should Greater then Valid From Date.";
      return false;
    }
    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = "";
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    if (this.ContractCompany != null) {
      if (this.ContractCompany.length != 0) {
        for (var i = this.ContractCompany.length - 1; i >= 0; i--) {
          var v1 = this.ContractCompany[i].CompanyName;
          var v2 = this.ContractCompany[i].CompanyRole;
          var v3 = this.ContractCompany[i].CompanyDate;
          debugger;
          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarCompanyName == undefined || vVarCompanyName == "" || vVarCompanyName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Company.";
            return false;
          }

          if (vVarCompanyRole == undefined || vVarCompanyRole == "" || vVarCompanyRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Role.";
            return false;
          }

          if (vVarCompanyDate == undefined || vVarCompanyDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Company Signed Date.";
            return false;
          }

          if (vValidfrom > vVarCompanyDate || vValidTo < vVarCompanyDate) {
            this.isShownError = false;
            this.ErrorMsg = "Company Signed Date should between Valid From and Valid To Date .";
            return false;
          }
        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Company Details..";
      return false;
    }

    if (this.ContractClient != null) {
      if (this.ContractClient.length != 0) {
        for (var i = this.ContractClient.length - 1; i >= 0; i--) {
          var v1 = this.ContractClient[i].ClientName;
          var v2 = this.ContractClient[i].ClientRole;
          var v3 = this.ContractClient[i].ClientDate;
          debugger;
          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);
          debugger;
          if (vVarClientName == undefined || vVarClientName == "" || vVarClientName == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Signed Client.";
            return false;
          }

          if (vVarClientRole == undefined || vVarClientRole == "" || vVarClientRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Role.";
            return false;
          }

          if (vVarClientDate == undefined || vVarClientDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Enter Client Signed Date.";
            return false;
          }

          if (vValidfrom > vVarClientDate || vValidTo < vVarClientDate) {
            this.isShownError = false;
            this.ErrorMsg = "Client Signed Date should between Valid From and Valid To Date .";
            return false;
          }
        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Signed Client Details..";
      return false;
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dContractName', this.onboardingid);
    params = params.append('dPurchaseNumber', this.PurchaseNumber);
    params = params.append('dContractNumber', this.ContractNumber);
    params = params.append('dService', this.type);
    params = params.append('dValidfrom', this.Validfrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('ddescription', this.description);
    params = params.append('iContracts', this.EditedContractId);
    params = params.append('istatus', vStatus)

    var value = this.http.get(environment.apiUrl + 'Contract/UpdateContract', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var ContractId = data;
        for (var i = this.ContractCompany.length - 1; i >= 0; i--) {
          var v1 = this.ContractCompany[i].CompanyName;
          var v2 = this.ContractCompany[i].CompanyRole;
          var v3 = this.ContractCompany[i].CompanyDate;

          var vVarCompanyName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarCompanyRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarCompanyDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params1 = new HttpParams();
          params1 = params1.append('icompanyid', this.EditedCompanyId);
          params1 = params1.append('iContractId', ContractId);
          params1 = params1.append('iCompanyName', vVarCompanyName);
          params1 = params1.append('irole', vVarCompanyRole);
          params1 = params1.append('iDate', vVarCompanyDate);
          var value = this.http.get(environment.apiUrl + 'Contract/UpdateContractsCompany', { params: params1 }).toPromise().then((data))
        }
        for (var i = this.ContractClient.length - 1; i >= 0; i--) {
          var v1 = this.ContractClient[i].ClientName;
          var v2 = this.ContractClient[i].ClientRole;
          var v3 = this.ContractClient[i].ClientDate;

          var vVarClientName = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarClientRole = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarClientDate = ((document.getElementById(v3) as HTMLInputElement).value);

          let params2 = new HttpParams();
          params2 = params2.append('iclientid', this.EditedClientId);
          params2 = params2.append('sContractId', ContractId);
          params2 = params2.append('sCompanyName', vVarClientName);
          params2 = params2.append('srole', vVarClientRole);
          params2 = params2.append('sDate', vVarClientDate);
          var value1 = this.http.get(environment.apiUrl + 'Contract/UpdateContractsClient', { params: params2 }).toPromise().then((data))
        }
        // var spliturl = this.updatedocid;
        // debugger;
        // for (var i = 0; i < spliturl.length; i++) {
        //   var furl = spliturl[i];
        //   var vvuid = furl.updocid;
        //   var vvurl = furl.upfileurl;
        //   let params3 = new HttpParams();
        //   params3 = params3.append('nContractId', ContractId);
        //   params3 = params3.append('nfurl', vvurl);
        //   params3 = params3.append('idocumentId', vvuid);
        //   debugger;
        //   var value2 = this.http.get(environment.apiUrl + 'Contract/UpdateContractsDoc', { params: params3 }).toPromise().then((data))
        //   debugger;
        // }
        var spliturl = this.surl;
        debugger;
        // for (var i = 0; i < spliturl.length; i++) {
        //   var furl = spliturl[i];
        if (spliturl != undefined && spliturl != "") {
          let params3 = new HttpParams();
          params3 = params3.append('sContractId', this.EditedContractId);
          params3 = params3.append('sfurl', spliturl);
          var value2 = this.http.get(environment.apiUrl + 'Contract/InsertContractsDoc', { params: params3 }).toPromise().then((data))

        }
        // let params3 = new HttpParams();
        // params3 = params3.append('sContractId', ContractId);
        // params3 = params3.append('sfurl', spliturl);
        // params3 = params.append('idocId', this.vardocid);
        // debugger;
        // var value2 = this.http.get(environment.apiUrl + 'Contract/UpdateContractsDoc', { params: params3 }).toPromise().then(
        //   (data: any) => {
        //   debugger;
        this.isShownSuccess = false;
        this.SuccessMsg = "Contracts Updated.";
        this.BindContractGrid();
        this.BindContractExport();
        this.isShownActive = true;
        this.isShownUpdateBtn = true;
        this.isShownSaveBtn = false;
        this.ContractName = "";
        this.PurchaseNumber = "";
        this.ContractNumber = "";
        this.surl = "";
        this.selects = [];
        this.select = "";
        this.Service = "";
        this.Validfrom = "";
        this.ValidTo = "";
        this.CompanyName = "";
        this.CompanyRole = "";
        this.CompanyDate = "";
        this.ClientName = "";
        this.ClientRole = "";
        this.ClientDate = "";
        this.description = "";
        var vcustomcode = this.sOnboardingId;
        this.onboardingid =vcustomcode;
        this.type = "";
        this.isShowndoclist = true;
        this.ContractCompany = [];
        this.ContractCompany.push({ CompanyName: "vCompanyName1", CompanyRole: "vCompanyRole1", CompanyDate: "vCompanyDate1" });
        this.ContractClient = [];
        this.ContractClient.push({ ClientName: "vClientName1", ClientRole: "vClientRole2", ClientDate: "vClientDate3" });
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }

  BindContractGrid() {
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Contract/GetContractForGrid',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindContractExport() {
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Contract/GetContractsForExport',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.ContractExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.ContractExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Contracts');

    /* save to file */
    XLSX.writeFile(wb, "Contracts.xlsx");

  }

  RemoveCompany(item: any) {
    debugger;
    this.ContractCompanyRemove = item;

    if (this.ContractCompany != null) {

      if (this.ContractCompany.length != 0 && this.ContractCompany.length != 1) {
        for (var i = this.ContractCompany.length - 1; i >= 0; i--) {
          //vName: v1, vPrice: v2, vImage: v3
          var v1 = this.ContractCompany[i].CompanyName;
          var vNme = this.ContractCompanyRemove.CompanyName;

          if (v1 == vNme) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You want to remove this Row!',

              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!',
              cancelButtonText: 'No, keep it'
            }).then((result) => {
              if (result.value) {
                this.ContractCompany.splice(i, 1);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Swal.fire(
                //   'Cancelled',
                //   'Your Row is safe :)',
                //   'error'
                // )
              }
            })

          }
        }
      }
      else {
        Swal.fire('', 'You Cannot Delete The Master Record.')
      }
    }
  }

  RemoveClient(item: any) {
    debugger;
    this.ContractClientRemove = item;

    if (this.ContractClient != null) {

      if (this.ContractClient.length != 0 && this.ContractClient.length != 1) {
        for (var i = this.ContractClient.length - 1; i >= 0; i--) {
          var v1 = this.ContractClient[i].ClientName;
          var vNme = this.ContractClientRemove.ClientName;

          if (v1 == vNme) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You want to remove this Row!',

              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!',
              cancelButtonText: 'No, keep it'
            }).then((result) => {
              if (result.value) {
                this.ContractClient.splice(i, 1);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Swal.fire(
                //   'Cancelled',
                //   'Your Row is safe :)',
                //   'error'
                // )
              }
            })

          }
        }
      }
      else {
        Swal.fire('', 'You Cannot Delete The Master Record.')
      }
    }
  }

  RemoveDocument(item: any,index) {

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to remove this File!',

      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.selects.splice(index,1);
        if(item.docid == undefined)
{
  let params = new HttpParams();
    params = params.append('lDocumentId', item.docid);
    var value = this.http.get(environment.apiUrl + 'Contract/DeleteContractsDoc', { params: params }).toPromise().then(
      (data: any) => {
       
        var returnValue = data;
        return false;
      }).catch((data: any) => {
        
        var vDataError = JSON.stringify(data.error.text);
       
              var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Delete Failed, Please Try Again.";
          return false;
        }
        else if(vErrorMsg1 == "Success")
        {
          
          return false;
  
        }

  


  });
}

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    })
     
  

  }
}
  
  

